import React from 'react';
import {
	AlertDialog,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogTrigger,
} from "../../components/ui/alert-dialog";
import { Button } from "../../components/ui/button";

import Close from '../../assets/kinologyIcons/svg/close.svg';
import {ReactComponent as Warning} from '../../assets/kinologyIcons/svg/WorningRed.svg';

import { useSelector } from 'react-redux';

interface PanelProps {
	open: boolean
	close:()=> void;
	action: ()=> void;
};

const DeletePanelCreated: React.FC<PanelProps> = ({
	action,
	close,
	open
})=> {

	
	const load_delete = useSelector(
		(state: any) => state.dashboard.load_delete_panel_dash_dynalabs
	);
		
	return (
		<AlertDialog 
			open={open} 
			onOpenChange={()=>close()}
		>
			<AlertDialogContent
				className={`w-[350px] bg-[#F1F2F3] flex flex-col items-center justify-center p-10 rounded-xl`}
			>
				<AlertDialogTrigger className={`absolute right-5 top-5`} onClick={()=>	{}}>
					<img src={Close} alt="" className={`w-4 h-4 cursor-pointer`} />
				</AlertDialogTrigger>

				<AlertDialogTrigger className={`self-center `} onClick={()=>	{}}>
					<Warning className={` w-12 h-12 self-center`} color={'#D12600'} />
				</AlertDialogTrigger>

				<AlertDialogDescription className={`text-center  text-[#000E4B] font-bold text-xl font-[Noto Sans]`}
				>
					Tem certeza de que deseja excluir o painel?
				</AlertDialogDescription>

				<AlertDialogDescription className={`text-center mt-5 text-[#63677A] font-normal text-xs font-[Noto Sans] `}
				>
					Não será possível recuperar esse painel.
				</AlertDialogDescription>
				<AlertDialogDescription className={`flex w-full justify-between  `}>
					<Button
						onClick={() =>{
							action()
						}}
						className={`w-[48%] p-4 items-center border-2 border-[#D12600] rounded-lg  text-[#000E4B] font-semibold font-[Kanit-Regular]`}
					>
						{
							load_delete
							? <div className="flex items-center justify-center h-4">
									<div className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-solid border-[#000E4B] border-t-transparent"></div>
								</div>
							: "Excluir painel" 
						}
						
					</Button>
					<Button
						onClick={() =>{
							close()
						}}
						className={`w-[48%] p-4 items-center border-2 border-[#000E4B] rounded-lg text-[#000E4B] font-semibold font-[Kanit-Regular]`}
					>
						Cancelar exclusão
					</Button>
				</AlertDialogDescription>
			</AlertDialogContent>
		</AlertDialog>
	);
};
export default DeletePanelCreated;